import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { addPolicyToPath } from './addPolicyToPath';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { getCustomerPolicyAction } from 'actions/getCustomerPolicyAction';
import { PolicyDetail } from 'interfaces/customerDataTypes';

interface SetSelectedPolicyProps {
  policyNumber: string;
  policyDetailsId: string;
  historyId: number;
  selectedPolicy?: PolicyDetail;
}

export const useSetSelectedPolicy = ({
  policyNumber,
  policyDetailsId,
  selectedPolicy,
  historyId
}: SetSelectedPolicyProps): void => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { pathname, search } = useLocation();
  const authentication = useAppSelector((state) => state.authentication);
  const { email: username, isAgent } = authentication;

  useEffect(() => {
    if (!selectedPolicy) {
      dispatch(getCustomerPolicyAction({ policyDetailsId, historyId, policyNumber, username, isAgent }));
      history.replace(addPolicyToPath(pathname, policyNumber) + search);
    }
  }, [policyNumber, policyDetailsId]);
};
